<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
    <div v-if="mechanismDialogVisible" class="breadcrumb-container">
      <!-- <span class="font-size14">当前机构：</span> -->
      <tree-select
        :props="defaultProps"
        :options="depts"
        :value="deptName - 0"
        class="currentInstitution"
        @getValue="changeDept"
      />
      <!-- <el-select v-model="deptName" size="mini" class="currentInstitution">
        <el-option
          v-for="item in depts"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <el-option :value="depts" class="select-tree">
          <el-tree
            :data="depts"
            highlight-current
            check-on-click-node
            default-expand-all
            :props="{
              label: 'name',
              children: 'childList'
            }"
            @node-click="changeDept"
          />
        </el-option>
      </el-select> -->
      <!-- <el-cascader v-model="deptName" :options="depts" :show-all-levels="false" :props="{label:'name',value:'id'}" /> -->
    </div>
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!--        <search id="header-search" class="right-menu-item" />-->

        <!-- <el-tooltip content="项目文档" effect="dark" placement="bottom">
          <Doc class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <!-- <el-tooltip content="全屏缩放" effect="dark" placement="bottom">
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <!-- <el-tooltip content="布局设置" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>
      <div id="iconBellIcon" :data-content-after="noticeContent" :class="noticeContent>0?'bellIcon':''">
        <svg-icon icon-class="bell" @click.stop="notification" />
      </div>
      <el-dropdown
        class=" right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <div style="display: flex;align-items: center;">
            <i class="el-icon-user" />
            {{ user.realName }}
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <span @click="openUserInfo">
            <el-dropdown-item> 用户信息 </el-dropdown-item>
          </span>
          <span v-hasPermi="['user:resetpassword']" @click="changePassword">
            <el-dropdown-item> 修改密码 </el-dropdown-item>
          </span>
          <span @click="open">
            <el-dropdown-item> 退出 </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- <i class="el-icon-more" /> -->
      <!-- <i class="el-icon-more" /> -->
      <!--      <svg-icon-->
      <!--        :icon-class=" 'signOut' "-->
      <!--        @click="open"-->
      <!--      />-->
      <!-- <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img :src="avatarImg" class="user-avatar">
          <i class="el-icon-more" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <span style="display:block;" @click="show = true">
            <el-dropdown-item>
              布局设置
            </el-dropdown-item>
          </span>
          <router-link to="/user/center">
            <el-dropdown-item>
              个人中心
            </el-dropdown-item>
          </router-link>
          <span style="display: block" @click="open">
            <el-dropdown-item> 退出登录 </el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <messageBox
      ref="messageBox"
      :customer-type="customerType"
      @messageContent="messageContent"
    />
    <reminder
      ref="reminder"
      :data-list-array="messageDataList"
      :customer-type="customerType"
    />
    <modifyTheUserPassword ref="modifyTheUserPassword" />
    <user-info-dialog ref="userInfoDialogRef" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import crudDept from '@/api/system/dept'
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import messageBox from './messageBox'
import reminder from './reminder'
import modifyTheUserPassword from './modifyTheUserPassword'
// import Doc from '@/components/Doc'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'
import Avatar from '@/assets/images/avatar.png'
import avatarImg from '@/assets/images/logos.png'
import TreeSelect from './TreeSelect/index'
import { getDictSubItem } from '@/api/system/dict'
import { nonResidentTypeDictionary, householdTypeDictionary } from '@/utils/constant'
import UserInfoDialog from '@/layout/components/userInfo/index.vue'
export default {
  components: {
    UserInfoDialog,
    // Breadcrumb,
    // Screenfull,
    reminder,
    messageBox,
    Hamburger,
    TreeSelect,
    modifyTheUserPassword
  },
  data() {
    return {
      deptName: '',
      Avatar: Avatar,
      dialogVisible: false,
      depts: [],
      avatarImg: avatarImg,
      value: '',
      mechanismDialogVisible: true,
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'id'
      },
      defaultCheckedKeys: [],
      messageBoxLeft: '',
      messageBoxTop: '',
      // 消息通知
      websocketInformation: '',
      workOrderWebsockets: [],
      workOrderReconnectTimer: null,
      workOrderNoticeCount: 0,
      lastWorkOrderNoticeTime: 0,
      // 强提示通知数据
      messageDataList: {},
      customerType: [],
      bellIconRed: true
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'device', 'user', 'baseApi', 'organizationId']),
    show: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    content() {
      return this.$store.state.user.content
    },
    noticeContent() {
      return Number(this.content || 0) + Number(this.workOrderNoticeCount || 0)
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  mounted() {
    this.getAllTheTypesOfUsers()
    this.$refs.messageBox.submitForm((i) => {
      console.log(i)
      setTimeout(() => {
        this.$store.dispatch('setMessageContent', i)
      }, 0)
      this.$forceUpdate()
    })
    this.deptName = this.$store.state.user.organizationId
    this.depts = this.$store.state.user.orgs
    this.defaultCheckedKeys = [this.deptName]
    this.getBreadcrumb()
    // this.initWebSocketInformation()
    this.initWorkOrderWebSocket()
  },
  beforeDestroy() {
    this.closeWorkOrderWebSocket()
  },
  methods: {
    // 未读数量
    messageContent(i) {
      this.$store.dispatch('setMessageContent', i)
    },
    changePassword() {
      this.$refs.modifyTheUserPassword.dialogVisible = true
    },
    openUserInfo() {
      this.$refs.userInfoDialogRef.dialogVisible = true
    },
    getAllTheTypesOfUsers() {
      this.customerType = []
      // 获取住户类型字典
      getDictSubItem(householdTypeDictionary).then((rel) => {
        this.customerType.push(...rel.data)
      }).catch((err) => {
        this.$message.error(`请联系管理员,错误原因${err}`)
      }).finally(() => {
        if (this.mechanismHome && this.mechanismHome.length > 0) {
          this.userLoading = false
        }
      })
      // 获取非住户类型字典
      getDictSubItem(nonResidentTypeDictionary).then((rel) => {
        this.customerType.push(...rel.data)
      }).catch((err) => {
        this.$message.error(`请联系管理员,错误原因${err}`)
      }).finally(() => {
        if (this.mechanismHome && this.mechanismHome.length > 0) {
          this.userLoading = false
        }
      })
    },
    // websocket实时获取数据
    initWebSocket() {
      if (this.websocket) {
        this.websocket.close()
        this.websocket = null
      }
      this.websocket = new WebSocket(
        process.env.VUE_APP_WEBSOCKET_URL +
          '/ws/wsHandlerForFrontWithBackground'
      )
      // console.log(this.websocket)
      const that = this.websocket
      that.onopen = this.websocketonopen
      that.onerror = this.websocketonerror
      that.onmessage = this.websocketonmessage
      that.onclose = this.websocketclose
    },
    initWebSocketInformation() {
      if (this.websocketInformation) {
        this.websocketInformation.close()
        this.websocketInformation = null
      }
      this.websocketInformation = new WebSocket(
        process.env.VUE_APP_WS_API +
          `/webSocket/${this.user.id}`
      )
      const that = this
      this.websocketInformation.onopen = function(event) {
        console.log('onopen', event.data)
        // that.$refs.reminder.state = true
        // that.messageDataList = [[], []]
      }
      this.websocketInformation.onerror = function(event) {
        console.log('onerror', event.data)
      }
      this.websocketInformation.onmessage = function(event) {
        // debugger
        // console.log('onmessage', event.data)
        if (event.data) {
          try {
            const messageData = JSON.parse(event.data)

            const message = JSON.parse(messageData.msg)
            message.contentJson = JSON.parse(message.contentJson)
            // console.log('onmessage', message)
            if (that.$refs.reminder.state === false) {
              that.messageDataList = {}
              setTimeout(() => {
                that.$refs.reminder.state = true
              }, 0)
            } else {
              that.$refs.reminder.updatePage()
            }
            if (!that.messageDataList[message.type]) {
              that.messageDataList[message.type] = []
            }
            that.messageDataList[message.type].push(message)
            that.$refs.messageBox.submitForm((i) => {
              that.$store.dispatch('setMessageContent', i)
            })
            // console.log(that.messageDataList)
            if (that.$refs.messageBox.state) {
              that.$refs.messageBox.state = false
            }
          } catch (error) {
            that.$message.error({
              title: '错误',
              message: `刚刚来了一个消息，出现数据错误请联系管理员${error}`
            })
          }
        }
        // 测试接口数据
        // if (event.data) {
        //   try {
        //     const messageData = JSON.parse(event.data)
        //     let message = JSON.parse(messageData.msg)
        //     // console.log(message)
        //     message = JSON.parse(message)

        //     message.contentJson = JSON.parse(message.contentJson)
        //     // console.log('onmessage', message)
        //     if (that.$refs.reminder.state === false) {
        //       that.messageDataList = {}
        //       setTimeout(() => {
        //         that.$refs.reminder.state = true
        //         that.$refs.messageBox.submitForm((i) => {
        //           if (i > 0) {
        //             that.bellIconRed = true
        //           } else {
        //             that.bellIconRed = false
        //           }
        //         })
        //       }, 0)
        //     } else {
        //       that.$refs.reminder.updatePage()
        //     }
        //     if (!that.messageDataList[message.type]) {
        //       that.messageDataList[message.type] = []
        //     }
        //     that.messageDataList[message.type].push(message)
        //     // console.log(that.messageDataList)
        //     if (that.$refs.messageBox.state) {
        //       that.$refs.messageBox.state = false
        //     }
        //   } catch (error) {
        //     that.$message.error({
        //       title: '错误',
        //       message: `刚刚来了一个消息，出现数据错误请联系管理员${error}`
        //     })
        //   }
        // }
      }
      this.websocketInformation.onclose = function(event) {
        console.log('onclose', event.data)
      }
      // this.websocketInformation.onmessage('222')
    },
    getWorkOrderSocketBaseUrl() {
      if (process.env.VUE_APP_SOCKET_BASE_URL) {
        return process.env.VUE_APP_SOCKET_BASE_URL
      }
      return `${process.env.VUE_APP_WS_API}/websocket/`
    },
    initWorkOrderWebSocket() {
      if (typeof WebSocket === 'undefined') {
        console.log('您的浏览器不支持WebSocket，无法实时获取工单消息')
        return
      }
      const userInfo = this.user || {}
      const socketKeys = [userInfo.id, userInfo.username, userInfo.realName]
        .filter(item => item !== undefined && item !== null && `${item}`.trim())
      const keys = Array.from(new Set(socketKeys.map(item => `${item}`)))
      if (!keys.length) {
        return
      }
      this.closeWorkOrderWebSocket()
      const baseUrl = this.getWorkOrderSocketBaseUrl()
      this.workOrderWebsockets = keys.map(key => {
        const websocket = new WebSocket(`${baseUrl}orderflow/${encodeURIComponent(key)}`)
        websocket.onmessage = this.handleWorkOrderMessage
        websocket.onerror = this.scheduleWorkOrderReconnect
        websocket.onclose = this.scheduleWorkOrderReconnect
        return websocket
      })
    },
    closeWorkOrderWebSocket() {
      if (this.workOrderReconnectTimer) {
        clearTimeout(this.workOrderReconnectTimer)
        this.workOrderReconnectTimer = null
      }
      this.workOrderWebsockets.forEach(websocket => {
        websocket.onclose = null
        websocket.onerror = null
        websocket.onmessage = null
        websocket.close()
      })
      this.workOrderWebsockets = []
    },
    scheduleWorkOrderReconnect() {
      if (this.workOrderReconnectTimer) {
        return
      }
      this.workOrderReconnectTimer = setTimeout(() => {
        this.workOrderReconnectTimer = null
        this.initWorkOrderWebSocket()
      }, 3000)
    },
    handleWorkOrderMessage(event) {
      const message = event && event.data
      if (!message || message === 'heart beat') {
        return
      }
      const now = Date.now()
      if (now - this.lastWorkOrderNoticeTime < 500) {
        return
      }
      this.lastWorkOrderNoticeTime = now
      this.workOrderNoticeCount += 1
      this.speakWorkOrderNotice()
      this.$notify({
        title: '新工单提醒',
        message: '您有新的工单，请注意查收！',
        type: 'warning',
        duration: 5000
      })
    },
    speakWorkOrderNotice() {
      const text = '您有新的工单，请注意查收！'
      if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
        return
      }
      const utterance = new SpeechSynthesisUtterance(text)
      utterance.lang = 'zh-CN'
      window.speechSynthesis.cancel()
      window.speechSynthesis.speak(utterance)
    },
    jumpToReportOrderWorkbench() {
      this.workOrderNoticeCount = 0
      this.$router.push({ path: '/qualityControl/ReportOrder/ProblemTracking' }).catch(() => {})
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      )
      const first = matched[0]
      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: '首页' }}].concat(
          matched
        )
      }
      const mechanism = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )
      if (mechanism && mechanism.length > 0) {
        // console.log(mechanism[mechanism.length - 1].name)
        switch (mechanism[mechanism.length - 1].name) {
          case 'Org':
          case 'Role':
          case 'environmentConfigure':
          case '平台用户管理':
            this.mechanismDialogVisible = false
            break

          default:
            this.mechanismDialogVisible = true
            break
        }
      }
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return (
        name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
      )
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    changeDept(id, detail) {
      this.$store.dispatch('setOrganizationId', [id, detail])
      setTimeout(() => {
        location.reload()
      }, 300)
    },
    // getDepts() {
    //   crudDept.getDepts({ enabled: true }).then(res => {
    //     this.depts = res.content
    //   })
    // },
    open() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    notification(event) {
      if (this.workOrderNoticeCount > 0) {
        this.jumpToReportOrderWorkbench()
        return
      }
      if (this.$refs.messageBox) {
        this.$refs.messageBox.state = true
        // this.$refs.messageBox.submitForm((i) => {
        //   this.$refs.messageBox.state = true
        //   if (i > 0) {
        //     this.bellIconRed = true
        //   } else {
        //     this.bellIconRed = false
        //   }
        // })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
.select-tree {
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  padding: 0;
}
.currentInstitution {
  position: absolute;
  left: 56px;
  top: 10px;
  width: 190px;
  height: 32px;
  ::v-deep .el-input {
    height: 100%;
  }
  ::v-deep .el-input__inner {
    height: 100%;
    border-radius: 24px;
    border: 1px solid rgba(37, 37, 37, 0.25);
  }
}
.navbar {
  height: $mainTop;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .hamburger-container {
    // line-height: 46px;
    position: absolute;
    left: 20px;
    top: 14px;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
    .el-select {
      .el-input {
        .el-input__inner {
          height: 26px;
        }
      }
    }
  }
  .font-size14 {
    font-size: 14px;
  }

  .breadcrumb-container {
    float: left;
    flex: 1;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    height: 100%;
    position: absolute;
    top: 4px;
    right: 24px;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }
    .svg-icon {
      width: 28px;
      height: 26px;
      margin: 11px 10px;
      fill: currentColor;
      color: #000;
      cursor: pointer;
    }
    .el-icon-search,
    .el-icon-user,
    .el-icon-more {
      width: 48px;
      height: 48px;
      font-size: 24px;
    }
    .el-icon-search::before,
    .el-icon-user::before,
    .el-icon-more::before {
      position: relative;
      left: 12px;
      top: 12px;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.bellIcon:after {
    content: attr(data-content-after);
    background-color: red;
    display: block;
    // width: 32px;
    height: 14px;
    border-radius: 14px;
    position: absolute;
    top: 8px;
    left: 24px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 14px;
    padding:0 5px;
}
</style>
